// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { DrugGroupsState } from '../_reducers/drug-group.reducers';
import { DrugGroup } from '../_models/drug-group.model';

export const selectDrugGroupsState = createFeatureSelector<DrugGroupsState>('drugGroups');

export const selectDrugGroupById = (drugGroupId: number) =>
  createSelector(selectDrugGroupsState, (drugGroupsState) => drugGroupsState.entities[drugGroupId]);

export const selectDrugGroupsPageLoading = createSelector(
  selectDrugGroupsState,
  (drugGroupsState) => {
    return drugGroupsState.listLoading;
  },
);

export const selectDrugGroupsActionLoading = createSelector(
  selectDrugGroupsState,
  (drugGroupsState) => drugGroupsState.actionsloading,
);

export const selectLastCreatedDrugGroupId = createSelector(
  selectDrugGroupsState,
  (drugGroupsState) => drugGroupsState.lastCreatedDrugGroupId,
);

export const selectDrugGroupsPageLastQuery = createSelector(
  selectDrugGroupsState,
  (drugGroupsState) => drugGroupsState.lastQuery,
);
export const selectDrugGroupError = createSelector(
  selectDrugGroupsState,
  (drugGroupsState) => drugGroupsState.error,
);
export const selectDrugGroupLatestSuccessfullAction = createSelector(
  selectDrugGroupsState,
  (drugGroupsState) => drugGroupsState.latestSuccessfullAction,
);
export const selectDrugGroupsInStore = createSelector(selectDrugGroupsState, (drugGroupsState) => {
  const items = (drugGroupsState.ids as number[])
    .map((id) => drugGroupsState.entities[id])
    .filter((item): item is DrugGroup => item !== undefined);
  return new QueryResultsModel(items, drugGroupsState.totalCount);
});

export const selectDrugGroupsShowInitWaitingMessage = createSelector(
  selectDrugGroupsState,
  (drugGroupsState) => drugGroupsState.showInitWaitingMessage,
);

export const selectHasDrugGroupsInStore = createSelector(selectDrugGroupsState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
